"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LottieAnimationAPI2 = _interopRequireDefault(require("./LottieAnimationAPI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var imageBaseSize = 250;

var LottieOutroAPI = /*#__PURE__*/function (_LottieAnimationAPI) {
  _inherits(LottieOutroAPI, _LottieAnimationAPI);

  var _super = _createSuper(LottieOutroAPI);

  function LottieOutroAPI() {
    _classCallCheck(this, LottieOutroAPI);

    return _super.apply(this, arguments);
  }

  _createClass(LottieOutroAPI, [{
    key: "updateLogoSizeAndPosition",
    value: function updateLogoSizeAndPosition(rect) {
      this._validate();

      this.animation.renderer.elements.forEach(function (elem) {
        if (elem.constructor.name === 'SVGCompElement' && elem.data.nm.indexOf('logo_precomp') !== -1) {
          var scale = elem.layerElement.transform.baseVal.getItem(0).matrix.a;

          if (rect.hasOwnProperty('width') && rect.hasOwnProperty('height')) {
            scale = rect.width / imageBaseSize; // matrix.a = matrix.d = scale

            elem.layerElement.transform.baseVal.getItem(0).matrix.a = scale;
            elem.layerElement.transform.baseVal.getItem(0).matrix.d = scale;
          }

          if (rect.hasOwnProperty('x') && rect.hasOwnProperty('y')) {
            elem.layerElement.transform.baseVal.getItem(0).matrix.e = rect.x + -25 * scale;
            elem.layerElement.transform.baseVal.getItem(0).matrix.f = rect.y + -25 * scale;
          }
        }
      });
    }
  }, {
    key: "updateLogoScale",
    value: function updateLogoScale(value) {
      this._validate();

      var _this$logo$style = this.logo.style,
          imageOriginWidth = _this$logo$style.imageOriginWidth,
          imageOriginHeight = _this$logo$style.imageOriginHeight;
      var imageWidth;
      var imageHeight;
      var maxSize = imageBaseSize * value;

      if (imageOriginWidth > imageOriginHeight) {
        // based on the width
        imageWidth = maxSize;
        imageHeight = imageWidth / imageOriginWidth * imageOriginHeight;
      } else {
        // based on the height
        imageHeight = maxSize;
        imageWidth = imageHeight / imageOriginHeight * imageOriginWidth;
      }

      this.animation.renderer.elements.forEach(function (elem) {
        if (elem.constructor.name === 'SVGCompElement' && elem.data.nm.indexOf('logo_precomp') !== -1) {
          var imageG = elem.elements[1].layerElement;
          imageG.transform.baseVal.getItem(0).matrix.e = (imageBaseSize - imageWidth) * 0.5 + 25;
          imageG.transform.baseVal.getItem(0).matrix.f = (imageBaseSize - imageHeight) * 0.5 + 25;
          imageG.firstChild.setAttribute('width', "".concat(imageWidth, "px"));
          imageG.firstChild.setAttribute('height', "".concat(imageHeight, "px"));
        }
      });
    }
  }]);

  return LottieOutroAPI;
}(_LottieAnimationAPI2.default);

exports.default = LottieOutroAPI;